import {Component, forwardRef, Injector, Input} from "@angular/core";
import {ColumnComponent} from "../../../framework/entity/grid/column.component";
import {MetaTagType} from "../meta-tag.data";
import {
    AbstractMultiSelectColumnComponent
} from "../../../framework/entity/edit/edit-grid/columns/abstract-multi-select-column.component";

@Component({
    selector: "wbo-meta-tag-multi-select-column",
    templateUrl: "./meta-tag-multi-select-column.component.html",
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => MetaTagMultiSelectColumnComponent), multi: true}
    ]
})
export class MetaTagMultiSelectColumnComponent extends AbstractMultiSelectColumnComponent {
    @Input() type: MetaTagType;
    @Input() includeMatchNoTags: boolean = false;

    constructor(injector: Injector) {
        super(injector, "metaTagDefinitionId", "name");
    }
}
